const { abstractResource } = require("./abstractResource");

const service = abstractResource("COMMERCIAL");

const Tax = {
  ...service("taxes"),
  get_form() {
    return {
      name: null,
      abbreviation: null,
      number: 0.0,
      is_active: true,
      account_sale: null,
      account_purchase: null,
    };
  },
};

const PriceLevel = {
  ...service("price-levels"),
  get_form() {
    return {
      name: null,
      type: null,
      is_active: true,
    };
  },

  get_type_choices() {
    return [
      { text: "Vente", value: "sale" },
      { text: "Achat", value: "purchase" },
    ];
  },
};

const Transaction = {
  get_form() {
    return {
      number: null,
      stockage_area: null,
      external_refs: null,
      organization: null,
      total_quantity: true,
      is_sales: false,
      company: "1",
    };
  },

  get_public_form() {
    return {
      number: null,
      organization: null,
      total_quantity: null,
    };
  },

  get_sending_status() {
    return [
      { text: "Non envoyé", value: "not_send" },
      { text: "Envoyé", value: "send" },
      { text: "Lu", value: "read" },
    ];
  },
};

const SendTransaction = {
  ...service("send-transaction"),

  get_form() {
    return {
      data: null,
      default: true,
      emails: [],
      type: null,
    };
  },
};

const TransactionSale = {
  get_form() {
    return {
      ...Transaction.get_form(),
      total_price: true,
      sub_total_price: true,
      total_taxes: true,
      legal_policy: null,
      created_at: null,
      ref: null,
    };
  },

  
  get_public_form() {
    return {
      ...Transaction.get_public_form(),
      total_taxes: null,
      sub_total_price: null,
      total_price: null,
      legal_policy: null,
      ref: null,
      created_at: null,
    };
  },
};

const TransactionLine = {
  get_form() {
    return {
      product_name: null,
      product: null,
      quantity: 0,
      transaction: null,
      available_stock: true,
      is_valid: true,
    };
  },
};

const TransactionLineSale = {
  get_form() {
    return {
      ...TransactionLine.get_form(),
      price: 0,
      discount: 0,
      taxes: [],
      total: true,
    };
  },
};

const InvoiceLine = {
  ...service("invoice-lines"),
  get_form() {
    return {
      ...TransactionLineSale.get_form(),
      available_stock: false,
      label: null,
    };
  },
};

const QuotationLine = {
  ...service("quotation-lines"),
  get_form() {
    return {
      ...TransactionLineSale.get_form(),
    };
  },
};

const PurchaseOrderLine = {
  ...service("purchase-order-lines"),
  get_form() {
    return {
      ...TransactionLineSale.get_form(),
    };
  },
};

const DeliveryNoteLine = {
  ...service("delivery-note-lines"),
  get_form() {
    return {
      ...TransactionLine.get_form(),
    };
  },
};

const CreditLine = {
  ...service("credit-lines"),
  get_form() {
    return {
      ...TransactionLineSale.get_form(),
      available_stock: false,
    };
  },
};

const RefundLine = {
  ...service("refund-lines"),
  get_form() {
    return {
      ...TransactionLineSale.get_form(),
      available_stock: false,
    };
  },
};

const ProductReturnLine = {
  ...service("product-return-lines"),
  get_form() {
    return {
      ...TransactionLine.get_form(),
      price: null,
    };
  },
};

const TransactionParam = {
  get_form() {
    return {
      transaction_taxes: [],
      price_level: null,
    };
  },
};

const TransactionParamSale = {
  get_form() {
    return {
      ...TransactionParam.get_form(),
      discount: 0,
    };
  },
};

const DeliveryParam = {
  get_form() {
    return {
      cost: 0,
      delivery_taxes: [],
    };
  },
};

const DeliveryParamAddress = {
  get_form() {
    return {
      ...DeliveryParam.get_form(),
      delivery_address: null,
      delivery_city: null,
      delivery_postal_code: null,
      delivery_country: null,
      delivery_date: null,
      delivery_contact: null,
      delivery_phone: null,
      delivery_email: null,
      tracking: null,
    };
  },
};

const InvoiceParam = {
  get_form() {
    return {
      invoice_address: null,
      invoice_city: null,
      invoice_postal_code: null,
      invoice_country: null,
      invoice_phone: null,
      invoice_contact: null,
      invoice_email: null,
      invoice_iban: null,
      invoice_bic: null,
    };
  },
};

const InvoicePayment = {
  ...service("invoice-payments"),
  get_form() {
    return {
      note: null,
      payment_method: null,
      amount: null,
      invoice: null,
      payment_date: new Date(),
    };
  },
  get_filters() {
    return {
      active: {
        is_sales: false,
        payment_status: false,
        provider: false,
        payment_date: false,
        invoice: false,
        justified: false,
      },
      form: {
        is_sales: false,
        payment_status: null,
        provider: null,
        payment_date: null,
        invoice: null,
        justified: false,
      },
    };
  },
  get_provider_choices() {
    return [
      { value: "bridge", text: "Bridge" },
      { value: "user", text: "Manuel" },
      { value: "reconciliation", text: "Réconciliation" },
    ];
  },
};

const InvoiceGroup = {
  ...service("invoice-groups"),
  outgoing_payments(id) {
    return this.request({
      method: "POST",
      url: `${this.url + id  }/outgoing_payments/`,
    });
  },
};

const Invoice = {
  ...service("invoices"),
  get_form() {
    return {
      ...TransactionSale.get_form(),
      ...TransactionParamSale.get_form(),
      ...InvoiceParam.get_form(),
      ...DeliveryParamAddress.get_form(),
      expiration_date: null,
      payment_method: null,
      linked_quotation: null,
      linked_purchase_order: null,
      linked_delivery_note: null,
      status: "pro_format",
      need_lines: false,
      installments: false,
      expiration_payment: false,
      ref: null,
    };
  },

  get_sending_status() {
    return Transaction.get_sending_status();
  },

  get_status() {
    return [
      { text: "Pro format", value: "pro_format" },
      { text: "Validée", value: "accepted" },
      { text: "Annulé", value: "canceled" },
    ];
  },

  get_colors() {
    return {
      pro_format: "warning",
      accepted: "success",
      canceled: "danger",
    };
  },

  get_payment_status() {
    return [
      { text: "Payée", value: "paid" },
      { text: "Impayée", value: "unpaid" },
      { text: "Partiellement payée", value: "partially_paid" },
    ];
  },

  get_payment_colors() {
    return {
      partially_paid: "warning",
      paid: "success",
      unpaid: "danger",
    };
  },

  get_sales_choices() {
    return [
      { text: "Avoirs", value: "credit" },
      { text: "Remboursements", value: "refund" },
    ];
  },

  incoming_payments(id, { data = {}, ...axiosConfig } = {}) {
    return this.request({
      method: "POST",
      url: `${this.url + id  }/incoming_payments/`,
      data,
      ...axiosConfig,
    });
  },

  outgoing_payments(id, { data = {}, ...axiosConfig } = {}) {
    return this.request({
      method: "POST",
      url: `${this.url + id  }/outgoing_payments/`,
      data,
      ...axiosConfig,
    });
  },

  get_expenses_choices() {
    return this.get_sales_choices();
  },

  getPurchaseOrderLines: {
    ...service("invoices/get_purchase_order_lines"),
  },

  public: {
    ...service("invoices/public"),

    get_form() {
      return {
        ...TransactionSale.get_public_form(),
        ...DeliveryParamAddress.get_form(),
        expiration_date: null,
        left_to_pay: null,
        payment_status: null,
        invoice_payments: null,
        delivery_date: null,
        ref: null,
      };
    },

    incoming_payments(id, { data = {}, ...axiosConfig } = {}) {
      return this.request({
        method: "POST",
        url: `${this.url + id  }/incoming_payments/`,
        data,
        ...axiosConfig,
      });
    },
  },

  getPdf(invoiceId, { ...axiosConfig } = {}) {
    return this.request({
      method: "GET",
      url: `${this.url + invoiceId}/get_pdf`,
      ...axiosConfig,
    });
  },
};

const Quotation = {
  name: "Quotation",
  ...service("quotations"),
  get_form() {
    return {
      ...TransactionSale.get_form(),
      ...TransactionParamSale.get_form(),
      ...InvoiceParam.get_form(),
      ...DeliveryParamAddress.get_form(),
      expiration_date: null,
      status: "pending",
      linked_quotations: [],
    };
  },

  get_sending_status() {
    return Transaction.get_sending_status();
  },

  get_status() {
    return [
      { text: "En attente", value: "pending" },
      { text: "Accepté", value: "accepted" },
      { text: "Annulé", value: "canceled" },
    ];
  },

  get_colors() {
    return {
      pending: "warning",
      accepted: "success",
      canceled: "danger",
    };
  },

  get_sales_choices() {
    return [
      { text: "Bons de commande", value: "purchase_order" },
      { text: "Factures", value: "invoice" },
    ];
  },

  get_expenses_choices() {
    return [
      { text: "Ordre d'achat", value: "purchase_order" },
      { text: "Factures", value: "invoice" },
    ];
  },

  ConvertInvoice: {
    ...service("quotations/convert_invoice"),
  },

  ConvertPurchaseOrder: {
    ...service("quotations/convert_purchase_order"),
  },

  Duplicate: {
    ...service("quotations/duplicate"),
  },

  NewVersion: {
    ...service("quotations/new_version"),
  },

  public: {
    ...service("quotations/public"),

    get_form() {
      return {
        ...TransactionSale.get_public_form(),
        ...DeliveryParamAddress.get_form(),
        expiration_date: null,
        delivery_date: null,
      };
    },
  },
};

const Credit = {
  ...service("credits"),
  get_form() {
    return {
      ...TransactionParam.get_form(),
      ...InvoiceParam.get_form(),
      ...DeliveryParam.get_form(),
      ...TransactionSale.get_form(),
      linked_product_return: null,
      linked_invoice: null,
      status: "pending",
      expiration_date: null,
      need_lines: false,
    };
  },

  get_status() {
    return [
      { text: "En attente", value: "pending" },
      { text: "Accepté", value: "accepted" },
      { text: "Annulé", value: "canceled" },
    ];
  },

  get_colors() {
    return {
      pending: "warning",
      accepted: "success",
      canceled: "danger",
    };
  },

  get_sending_status() {
    return Transaction.get_sending_status();
  },

  get_sales_choices() {
    return null;
  },

  get_expenses_choices() {
    return null;
  },

  getLines: {
    ...service("credits/get_lines"),
  },

  public: {
    ...service("credits/public"),

    get_form() {
      return {
        ...TransactionSale.get_public_form(),
        created_at: null,
      };
    },
  },
};

const PurchaseOrder = {
  ...service("purchase-orders"),
  get_form() {
    return {
      ...TransactionSale.get_form(),
      ...TransactionParamSale.get_form(),
      ...InvoiceParam.get_form(),
      ...DeliveryParamAddress.get_form(),
      status: "active",
    };
  },

  get_sending_status() {
    return Transaction.get_sending_status();
  },

  get_status() {
    return [
      { text: "Actif", value: "active" },
      { text: "Annulé", value: "canceled" },
      { text: "Terminé", value: "ended" },
    ];
  },

  get_colors() {
    return {
      active: "warning",
      ended: "success",
      canceled: "danger",
    };
  },

  get_sales_choices() {
    return [
      { text: "Ordres d'achat", value: "purchase_order" },
      { text: "Retours produits", value: "product_return" },
      { text: "Bons de livraison", value: "delivery_note" },
      { text: "Factures", value: "invoice" },
    ];
  },

  get_expenses_choices() {
    return [
      { text: "Renvois produit", value: "product_return" },
      { text: "Livraison", value: "delivery_note" },
      { text: "Factures", value: "invoice" },
    ];
  },

  getLines: {
    ...service("purchase-orders/get_lines"),
  },

  public: {
    ...service("purchase-orders/public"),

    get_form() {
      return {
        ...TransactionSale.get_public_form(),
        ...DeliveryParamAddress.get_form(),
      };
    },
  },
};

const ProductReturn = {
  ...service("product-returns"),
  get_form() {
    return {
      ...Transaction.get_form(),
      ...TransactionParam.get_form(),
      return_to_storage: false,
      linked_purchase_order: null,
      linked_invoice: null,
      status: "waiting",
      need_lines: false,
    };
  },

  get_sending_status() {
    return Transaction.get_sending_status();
  },

  get_status() {
    return [
      { text: "En attente", value: "waiting" },
      { text: "Annulé", value: "canceled" },
      { text: "Livré", value: "delivered" },
    ];
  },

  get_colors() {
    return {
      waiting: "warning",
      delivered: "success",
      canceled: "danger",
    };
  },

  get_sales_choices() {
    return [
      { text: "Avoirs", value: "credit" },
      { text: "Remboursements", value: "refund" },
    ];
  },

  get_expenses_choices() {
    return this.get_sales_choices();
  },

  getLines: {
    ...service("product-returns/get_lines"),
  },

  public: {
    ...service("product-returns/public"),

    get_form() {
      return {
        ...TransactionSale.get_public_form(),
      };
    },
  },
};

const DeliveryNote = {
  ...service("delivery-notes"),
  get_form() {
    const returnObject = {
      ...Transaction.get_form(),
      ...DeliveryParamAddress.get_form(),
      linked_purchase_order: null,
      status: "waiting",
      need_lines: false,
    };
    delete returnObject.cost;
    delete returnObject.delivery_taxes;
    return returnObject;
  },

  get_sending_status() {
    return Transaction.get_sending_status();
  },

  get_status() {
    return [
      { text: "En attente", value: "waiting" },
      { text: "En préparation", value: "preparing" },
      { text: "Prêt pour la livraison", value: "ready_to_deliver" },
      { text: "Expédié", value: "make_the_delivery" },
      { text: "Livré", value: "deliver" },
      { text: "Annulé", value: "canceled" },
    ];
  },

  get_colors() {
    return {
      waiting: "warning",
      canceled: "danger",
      ready_to_deliver: "secondary",
      preparing: "primary",
      make_the_delivery: "tertiary",
      deliver: "success",
    };
  },

  get_sales_choices() {
    return [{ text: "Factures", value: "invoice" }];
  },

  get_expenses_choices() {
    return this.get_sales_choices();
  },

  getPurchaseOrderLines: {
    ...service("delivery-notes/get_purchase_order_lines"),
  },

  public: {
    ...service("delivery-notes/public"),

    get_form() {
      return {
        ...Transaction.get_public_form(),
        ...DeliveryParamAddress.get_form(),
      };
    },
  },
};

const Refund = {
  ...service("refunds"),
  get_form() {
    return {
      ...TransactionSale.get_form(),
      ...TransactionParam.get_form(),
      ...InvoiceParam.get_form(),
      ...DeliveryParam.get_form(),
      linked_product_return: null,
      linked_invoice: null,
      status: "pending",
      need_lines: false,
    };
  },

  get_sending_status() {
    return Transaction.get_sending_status();
  },

  get_status() {
    return [
      { text: "En attente", value: "pending" },
      { text: "Accepté", value: "accepted" },
      { text: "Annulé", value: "canceled" },
    ];
  },

  get_payment_status() {
    return [
      { text: "Payée", value: "paid" },
      { text: "Impayée", value: "unpaid" },
      { text: "Partiellement payée", value: "partially_paid" },
    ];
  },

  get_payment_colors() {
    return {
      partially_paid: "warning",
      paid: "success",
      unpaid: "danger",
    };
  },

  get_sales_choices() {
    return null;
  },

  get_expenses_choices() {
    return null;
  },

  getLines: {
    ...service("refunds/get_lines"),
  },

  public: {
    ...service("refunds/public"),

    get_form() {
      return {
        ...TransactionSale.get_public_form(),
        left_to_pay: null,
        payment_status: null,
        refund_payments: null,
      };
    },
  },
};

const RefundPayment = {
  ...service("refund-payments"),
  get_form() {
    return {
      note: null,
      payment_method: null,
      amount: null,
      refund: null,
    };
  },
};

const BusinessOpportunity = {
  ...service("business-opportunities"),
};

const LabelRule = {
  ...service("label-rules"),
  get_form() {
    return {
      label: null,
      account: null,
      type: null,
      is_business_management_label: true,
      is_accounting_label: true,
      is_active: false,
    };
  },
};
const ClassificationRule = {
  ...service("classification-rules"),
  get_form() {
    return {
      name: null,
      rule: null,
      label: null,
      is_active: true,
    };
  },
};

const BusinessManagementYear = {
  ...service('business-management-years'),
}

const BusinessManagementMonth = {
  get_form(){
    return{
      month: null,
      total_in: 0.0,
      total_out: 0.0,
    }
  },
}

const BusinessManagementForecast = {
  ...service('business-management-forecasts'),
  get_form(){
    return{
      name: null,
      year: null,
    }
  },

  get_year_choices(){
    const years = []
    for(let i = 2018 ; i <= new Date().getFullYear() ; i++){
      years.push({text: `${i}`, value: i})
    }
    return years
  },
}

const BusinessManagementFlow = {
  ...service('business-management-flows'),
  get_form(){
    return{
      month: null,
      label: null,
      business_management_forecast: null,
      company: '1',
      type: null,
      total: 0,
    }
  },

  get_month_choices() {
    return[
      {text: 'Janvier', value: 1},
      {text: 'Février', value: 2},
      {text: 'Mars', value: 3},
      {text: 'Avril', value: 4},
      {text: 'Mai', value: 5},
      {text: 'Juin', value: 6},
      {text: 'Juillet', value: 7},
      {text: 'Août', value: 8},
      {text: 'Septembre', value: 9},
      {text: 'Octobre', value: 10},
      {text: 'Novembre', value: 11},
      {text: 'Décembre', value: 12},
    ]
  },

  get_type_choices(){
    return[
      {text: "Entrée d'argent", value: "in"},
      {text: "Sortie d'argent", value: "out"},
    ]
  },
}

const AgedScale = {
  ...service("aged-scales"),
}

const TotalAgedScale = {
  ...service("total-aged-scales"),
}

module.exports = {
  Tax,
  PriceLevel,
  Invoice,
  Quotation,
  DeliveryNote,
  Refund,
  ProductReturn,
  PurchaseOrder,
  Credit,
  InvoiceLine,
  QuotationLine,
  PurchaseOrderLine,
  DeliveryNoteLine,
  InvoicePayment,
  CreditLine,
  RefundLine,
  ProductReturnLine,
  BusinessOpportunity,
  RefundPayment,
  InvoiceGroup,
  SendTransaction,
  LabelRule,
  ClassificationRule,
  BusinessManagementYear,
  BusinessManagementMonth,
  BusinessManagementForecast,
  BusinessManagementFlow,
  AgedScale,
  TotalAgedScale,
};
